module.exports = __webpack_public_path__ + "img/3d25ef7e58e1fc991216269dbc6d79b3.svg";